import { makeObservable, observable, flow, computed, action } from "mobx";

import { api } from "@/lib/services";
import { ApiRoutes } from "@/lib/routes";
import { Edit, Add } from "@/components/icons/IconMap";
import { toast } from "sonner";

import BrowseItemWatchlistSchema from "@/areas/inventory/schemas/BrowseItemWatchlistSchema";

export default class BrowseItemWatchlistStore {
  loading = false;
  pagination = {};
  watchlistItems = [];

  constructor(parentStore) {
    makeObservable(this, {
      loading: observable,
      pagination: observable,

      watchlistItems: observable,
      actions: computed,
      consume: action,
      load: flow,
    });

    this.parentStore = parentStore;
  }
  get processing() {
    return this.loading;
  }

  get actions() {
    const list = [];
    return list;
  }

  consume(watchlistItem) {
    const index = this.watchlistItems.findIndex((e) => e.id === watchlistItem.id);
    if (index !== -1) {
      this.watchlistItems.splice(index, 1, watchlistItem);
      this.watchlistItems = [...this.watchlistItems];
    }
  }

  *load(query, options) {
    const watchlistQuery = {
      search: query.search,
      query: {
        ...query.query,
        inWatchlist: true,
      },
      sort: query.sort,
      page: query.page,
      pageSize: query.pageSize,
    };

    const parseResult = BrowseItemWatchlistSchema.safeParse(watchlistQuery);
    if (!parseResult.success) {
      console.error(parseResult.error);
      return parseResult;
    }

    try {
      this.loading = true;
      // this.query = parseResult.data;

      const response = yield api.post(ApiRoutes.forItemSearch(), watchlistQuery);

      this.watchlistItems = response.data.items;
      this.pagination = {
        page: response.data.page,
        totalItems: response.data.totalItems,
        totalPages: response.data.totalPages,
        pageSize: response.data.pageSize,
      };
      return { success: true, data: response.data };
    } catch (e) {
      toast.error("Error loading items", {
        description: e?.response?.data?.message || "Unexpected error, please try again later.",
      });
      return { success: false, error: e };
    } finally {
      this.loading = false;
    }
  }
}
